<template>
  <kd-layout-fixed-bottom-button
    button-text="确定"
    :disabled="loading"
    @click="confirm"
    class="create-leave-record-page"
  >
    <div class="form">
      <kd-form-item label="年级班级" required>
        <kd-class-select
          placeholder="请选择"
          v-if="options && options.length > 0"
          :value="selectedClass"
          @select="selectClazz"
        />
      </kd-form-item>

      <kd-form-item label="选择学生" required>
        <kd-select
          placeholder="请选择学生"
          :options="studentsOptions"
          @select="selectStudent"
          :value="studentName"
          :no-data-text="noOptionTip"
        >
        </kd-select>
      </kd-form-item>

      <kd-form-item label="请假类型" required>
        <kd-select placeholder="请选择" :options="leaveTypeOptions" :value="typeLabel" @select="selectType" />
      </kd-form-item>
      <kd-form-item label="开始日期" required>
        <kd-date-select placeholder="请选择" :value="startTime" @change="changeStartTime"> </kd-date-select>
      </kd-form-item>
      <kd-form-item label="结束日期" required>
        <kd-date-select placeholder="请选择" :start-date="startTime" :value="endTime" @change="changeEndTime">
        </kd-date-select>
      </kd-form-item>
      <div class="tip">
        请假时长共 <span>{{ durations }} </span>天
      </div>
      <attachments-uploader
        :img-upload-label="uploadLabelImg"
        :image-urls="exemptionUrls"
        @delImg="delImg"
        @uploadImg="handleImage"
        @uploadSuccess="uploadSuccess"
        @uploadFailed="uploadFailed"
      ></attachments-uploader>
    </div>
  </kd-layout-fixed-bottom-button>
</template>
<script lang="ts">
import { BasePage, Component, Watch } from 'kuaidong-component'
import { KdLayoutFixedBottomButton, KdFormItem, KdInput, KdSelect, KdDateSelect, KdClassSelect } from 'kuaidong-ui'
import { DateWrapper, Debounce } from 'kuaidong-lib'
import { Clazz, IExemptionForm, Option, SelectedClass, StudentLeave } from 'kuaidong-model'
import differenceInDays from 'date-fns/differenceInDays'
import AttachmentsUploader from './AttachmentsUploader.vue'
import uploadLabelImg from './assets/img_exemption_upload@2x.png'
import { AApprovalLeave, AClazz } from 'kuaidong-api'
import { ClassService, ExemptionService } from 'kuaidong-service'

interface StudentOption<T, U> {
  value: T
  label: U
}

@Component({
  components: {
    KdFormItem,
    KdLayoutFixedBottomButton,
    KdInput,
    KdSelect,
    KdDateSelect,
    KdClassSelect,
    AttachmentsUploader,
  },
})
export default class CreateLeaveRecordPage extends BasePage {
  get noOptionTip() {
    return '该年级班级无学生信息~'
  }
  get options() {
    return ClassService.buildClassOptions(this.clazzes)
  }

  get startTime() {
    return new DateWrapper(this.form.start_time).date
  }

  get endTime() {
    return new DateWrapper(this.form.end_time).date
  }

  get durations() {
    return differenceInDays(this.endTime, this.startTime) + 1
  }
  get exemptionUrls() {
    return this.form.attachments
  }
  get typeLabel() {
    return this.leaveTypeOptions.find((t) => t.value === this.form.type)!.label
  }

  clazzes: Clazz[] = []
  selectedClass: SelectedClass | null = null
  studentsOptions: StudentOption<string, string>[] = []
  studentName = ''

  uploadLabelImg = uploadLabelImg

  leaveTypeOptions: { label: StudentLeave; value: string }[] = [
    { label: StudentLeave.personal, value: 'personal' },
    { label: StudentLeave.sick, value: 'sick' },
    { label: StudentLeave.other, value: 'other' },
  ]
  form: IExemptionForm = {
    type: this.leaveTypeOptions[0].value,
    user_id: '',
    start_time: new DateWrapper(new Date()).showDateStr,
    end_time: new DateWrapper(new Date()).showDateStr,
    attachments: [] as string[],
  }

  async created() {
    this.clazzes = await AClazz.allMine()
  }

  validate() {
    if (!this.form.user_id) {
      this.toast('学生信息不能为空~')
      return false
    }

    if (this.durations <= 0) {
      this.toast('请假时长需大于0~')
      return false
    }
    return true
  }

  @Debounce()
  async confirm() {
    if (this.validate()) {
      // 创建请假记录
      try {
        this.loading = true
        await AApprovalLeave.addStudentLeave(this.form)
        this.toast('添加请假记录成功~')
        this.$router.push({
          name: 'approval_leave_list',
        })
      } catch (e) {
        if (e.data) {
          this.toast(e.data)
        } else {
          this.toast('添加请假记录失败~')
        }
      } finally {
        this.loading = false
      }
    }
  }

  selectType(op: Option<string>[]) {
    console.log(op)
    this.form.type = op[0].value
  }

  changeStartTime(op: Date) {
    this.form.start_time = op.toDateString()
  }

  changeEndTime(op: Date) {
    this.form.end_time = op.toDateString()
  }

  delImg(index: number) {
    this.form.attachments!.splice(index, 1)
  }

  uploadSuccess() {
    this.toast('上传成功')
  }

  uploadFailed() {
    this.toast('上传失败')
  }

  selectStudent(op: [StudentOption<string, string>]) {
    if (!op) return
    this.studentName = op[0].label
    this.form.user_id = op[0].value
  }

  async selectClazz(clazz: SelectedClass) {
    console.log(clazz)
    this.selectedClass = clazz
    if (this.clazzes?.length && this.selectedClass) {
      this.studentsOptions = (await ExemptionService.getSudentsOptions(this.clazzes, clazz)) || []
      console.log(this.studentsOptions)
    }
  }
  async handleImage(imageUrl: string) {
    this.form.attachments!.push(imageUrl)
  }

  @Watch('startTime')
  resetEndTime() {
    if (this.startTime > this.endTime) {
      this.form.end_time = this.form.start_time
    }
  }
}
</script>
<style lang="less">
.create-leave-record-page {
  > .kd-layout-fixed-bottom__main {
    padding: 16px;
    > .form {
      display: flex;
      flex-direction: column;
      background: #ffffff;
      width: 100%;
      padding: 26px 16px;
      box-sizing: border-box;

      .kd-form-item {
        &__label {
          &--required::before {
            content: '';
          }
          &--required::after {
            color: #e67f81;
            content: '*';
          }
        }
      }

      > .tip {
        font-weight: 500;
        font-size: 12px;
        line-height: 17px;
        color: #939599;
        margin-top: 11px;
        width: 100%;
        text-align: right;
        > span {
          color: #437fec;
        }
      }
    }
  }
}
</style>
